const defaultBaseUrl = process.env.REACT_APP_FUNCTION_BASE_URL;

async function callFunction(endpoint, payload) {
  if (!defaultBaseUrl) {
    throw new Error("Missing REACT_APP_FUNCTION_BASE_URL. Deploy Functions to get the URL.");
  }
  const response = await fetch(`${defaultBaseUrl}/${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload || {})
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || "Failed to call Firebase Function");
  }

  return response.json();
}

export async function requestPlan(payload) {
  return callFunction("planApp", payload);
}

export async function dispatchRuntime(payload) {
  return callFunction("dispatchApi", payload);
}

export async function sendDevChatMessage(payload) {
  console.log("sendDevChatMessage", payload)
  return callFunction("chatDev", payload);
}

export async function buildWebApp(payload) {
  return callFunction("buildWebApp", payload);
}

export async function composeApi(payload) {
  return callFunction("composeApi", payload);
}

export async function createCheckoutSession(payload) {
  return callFunction("createCheckoutSession", payload);
}

export async function runApiEndpoint(payload) {
  return callFunction("runApiEndpoint", payload);
}

export async function getPlanInfo(payload) {
  return callFunction("getPlanInfo", payload);
}

export async function listMcpTools(payload) {
  return callFunction("listMcpTools", payload);
}
